import { component } from 'picoapp'
import Cookies from 'js-cookie'
import '@/lib/jquery-global.js';

export default component((node, ctx) => {

  let cartCount = '';
  let cartToggles = '';

  if (node.querySelector('.js-cart-count')) {
    cartCount = node.querySelector('.js-cart-count')
  }

  if (node.querySelectorAll('.js-cart-drawer-toggle').length > 0) {
    cartToggles = node.querySelectorAll('.js-cart-drawer-toggle')
  }
  

  for (let i = 0; i < cartToggles.length; i++) {
    cartToggles[i].addEventListener('click', e => {
      e.preventDefault()

      ctx.emit('cart:toggle', state => {
        return {
          cartOpen: !state.cartOpen
        }
      })
    })
  }

  ctx.on('cart:updated', state => {
    cartCount.innerHTML = state.cart.item_count
  })

  cartCount.innerHTML = ctx.getState().cart.item_count

  
  const promo = jQuery('.js-promo')

  // if (Cookies.get('promo') == 'hide') {
  //   promo.hide();
  // }

  jQuery('.js-close-promo').click(function() { 
      // Cookies.set('promo', 'hide');
      promo.slideUp('fast');
  });

  if (document.querySelector('.js-search-toggle')) {
    document.querySelector('.js-search-toggle').addEventListener('click', function() {
      document.body.classList.add('search--open')
    })
  }
  

  document.querySelector('.js-overlay').addEventListener('click', function() {
    document.body.classList.remove('mm--open')
    document.body.classList.remove('cart--open')
    document.body.classList.remove('password--open')
    document.body.classList.remove('search--open')
    document.body.classList.remove('details--open')

    ctx.emit('cart:toggle', state => {
      return {
        cartOpen: false
      }
    })
  })

  // const filters = document.querySelectorAll('.js-filter')

  node.querySelector('.js-open-mm').addEventListener('click', function() {
    document.body.classList.add('mm--open')
  })


  jQuery('.js-close-mm').click(function() {
    document.body.classList.remove('mm--open')

    ctx.emit('cart:toggle', state => {
      return {
        cartOpen: false
      }
    })
  })


  if(jQuery('.has-megamenu').hasClass('active')) {
    jQuery('.js-spacer-with-megamenu').show();

    if (document.querySelector('.js-product-top')) {
      jQuery('.js-product-top').css({ top: '101px' });
    }

  } else {
    jQuery('.js-spacer').show();

    if (document.querySelector('.js-product-top')) {
      jQuery('.js-product-top').css('top', '50px');
    }
  }

  

  // has-megamenu active

  // document.querySelector('.js-close-mm').addEventListener('click', function() {
    
  // })

})
